import Vue from 'vue';
import Vuex from 'vuex';

import alerts from './modules/alerts';
import auth from './modules/auth';
import countries from './modules/countries';
import currencies from './modules/currencies';
import customers from './modules/customers';
import languages from './modules/languages';
import orders from './modules/orders';
import settings from './modules/settings';
import users from './modules/users';
import files from './modules/files';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerts,
    auth,
    countries,
    currencies,
    customers,
    languages,
    orders,
    settings,
    users,
    files,
  },
});
